import type { DeathStats } from '@kenocyber/game-domain';
import { formatDuration, formatNumber } from './format';

interface DeathScreenProps {
  readonly stats: DeathStats;
  readonly cause: 'boss-breach' | 'mob-leaks';
  readonly onRestart: () => void;
}

/** Dark overlay with red neon: shown when the ship dies. */
export function DeathScreen({ stats, cause, onRestart }: DeathScreenProps) {
  return (
    <div className="death-overlay" data-testid="death-screen">
      <div className="death-box">
        <h2 className="death-title">NAVE DESTRUÍDA</h2>
        <p className="death-cause">
          {cause === 'boss-breach'
            ? 'O boss atravessou a linha inferior.'
            : 'Os inimigos romperam a defesa.'}
        </p>
        <dl className="death-stats">
          <div>
            <dt>Tempo sobrevivido</dt>
            <dd data-testid="death-survived">{formatDuration(stats.survivedMs)}</dd>
          </div>
          <div>
            <dt>Mobs abatidos</dt>
            <dd data-testid="death-kills">{stats.kills}</dd>
          </div>
          <div>
            <dt>Dano causado</dt>
            <dd>{formatNumber(stats.damageDealt)}</dd>
          </div>
          <div>
            <dt>Gold obtido</dt>
            <dd className="neon-gold">{formatNumber(stats.goldEarned, 0)}</dd>
          </div>
        </dl>
        <button
          type="button"
          className="death-button"
          data-testid="death-restart"
          onClick={onRestart}
        >
          Retornar à caçada
        </button>
      </div>
    </div>
  );
}
